import React from "react";
import CheckInDetails from "./modules/CheckInDetails";
import CheckInList from "./modules/CheckInList";
import { CheckInItem } from 'types';
import CheckInForm from "./modules/CheckInForm";
import styles from './CheckIn.module.scss';
import { store } from "stores/Store";
import useExternalApiService from "helpers/ExternalApiService";
  

enum Tab {
  CHECK_IN = "check_in",
  DETAILS = "details",
  FORM = "form"
}


const CheckIn = ({setIsHeaderHidden}: {setIsHeaderHidden: (isHidden: boolean) => void}) => {
  const [checkIns, setCheckIns] = React.useState<CheckInItem[]>();
  const [selectedTab, setSelectedTab] = React.useState<Tab>(Tab.CHECK_IN);
  const [selectedCheckIn, setSelectedCheckIn] = React.useState<CheckInItem | null>(null);

  const apiUrl = process.env.REACT_APP_EAI_URL;
  const { postData } = useExternalApiService(apiUrl);

  const navigateToCheckInList = () => {
    setCheckIns(undefined);
    setSelectedTab(Tab.CHECK_IN);
    store.clearCheckIn();
    getCheckIns();
  }

  React.useEffect(() => {
    // Don't open up check-ins automatiically.
    /*
    if(store.checkIn) {
      setSelectedTab(Tab.FORM);
    }*/

    getCheckIns();
  }, []);

  const getCheckIns = () => {
    const getCheckIns = async () => {
      const practitionerId = store.currentPractitioner?.id ?? '';
      const netsuiteId = store.currentPractitioner?.netsuite_id ?? '';      
      const bg_rowid = store.currentPractitioner?.bg_rowid ?? '';

      // Always fetch this
      const activeResult = await postData('/api/get_checkins_for_practitioner', {practitioner_id: practitionerId});

      // Only fetch archived if we have a proper netsuite ID
      //const archivedResult = await postData('/api/get_checkins_for_practitioner_archived', { internal_practitioner_netsuite_id: netsuiteId });
      const archivedResult = netsuiteId 
        ? await postData('/api/get_checkins_for_practitioner_archived', { internal_practitioner_netsuite_id: netsuiteId })
        : { checkins: [] };

      // Only fetch archivedBGResult if bg_rowid exists
      //const archivedBGResult = await postData('/api/get_checkins_for_practitioner_archived_bg', {badger_account_rowid: bg_rowid});
      const archivedBGResult = bg_rowid 
        ? await postData('/api/get_checkins_for_practitioner_archived_bg', {badger_account_rowid: bg_rowid})
        : { checkins: [] };

      // Tag archived check-ins
      const archivedCheckIns = archivedResult?.checkins.map((ci: CheckInItem) => ({
        ...ci,
        is_archived: true
      }));
      
      const archivedBGCheckIns = archivedBGResult.checkins.map((ci: CheckInItem) => ({
        ...ci,
        is_archived_bg: true
      }));

      const sortedActive = [...activeResult.checkins].sort(
        (a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
      );

      const sortedArchived = [...archivedCheckIns].sort(
        (a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
      );

      const sortedArchivedBG = [...archivedBGCheckIns].sort(
        (a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
      );                  
  
      //setCheckIns(result.checkins);
      setCheckIns([...sortedActive, ...sortedArchived, ...sortedArchivedBG]);
    }

    getCheckIns();
  }

  const handleCheckInClick = (checkIn: CheckInItem) => {
    setSelectedCheckIn(checkIn);
    setSelectedTab(Tab.DETAILS);
  }

  React.useEffect(() => {
    setIsHeaderHidden(selectedTab === Tab.FORM);
  }, [selectedTab, setIsHeaderHidden]);

  const renderTabContent = () => {
    switch (selectedTab) {
      case Tab.CHECK_IN:
        return <CheckInList onCheckInClick={handleCheckInClick} checkIns={checkIns} addNewCheckIn={() => setSelectedTab(Tab.FORM)}/>
        case Tab.FORM:
          return <CheckInForm navigateBack={navigateToCheckInList}/>  
      case Tab.DETAILS:
        if(selectedCheckIn) {
          return <CheckInDetails checkIn={selectedCheckIn} returnToCheckInList={() => setSelectedTab(Tab.CHECK_IN)}/>
        }
        return <p>No check-in selected</p>
    }
  }
  
  return (
    <div className={styles.wrapper}>
      {renderTabContent()}
    </div>
  );
};

export default CheckIn;